module.exports = __webpack_public_path__ + "static/img/tc1.f25e44c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tc1.jpg
// module id = WLZD
// module chunks = 1